<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data: () => ({}),
  async mounted() {
    console.info("App version " + this.$store.getters.getAppVersion);
  }
};
</script>
